import { formataData } from "../../../utils/formatacao";
import Botao from "../../Botao";

interface Props {
    produto: string;
    inicio: string;
    onClick: () => void;
    finalizar: () => void;
}

export default function CardProcesso({ produto, inicio, onClick, finalizar }: Props) {
    return (
        <div>
            <h3>Produto: {produto}</h3>

            <h3>Inicio: {formataData(inicio)}</h3>

            <Botao
                text={'Continuar'}
                onClick={onClick}
            />

            <Botao
                text={'Finalizar'}
                onClick={finalizar}
                style="blue"
            />
        </div>
    )
}